import { useMsal } from "@azure/msal-react";
import React from "react";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import MonadSelect from "ui/build/components/MonadSelect/MonadSelect";

import fetchEnv from "../../../utils/FetchEnv";
import { loginRequest } from "../../../utils/MSLoginConfig";
import { t } from "../../../utils/ResourceUtils";
import { mapSubtenantToUUID } from "../../../utils/SubTenantChange";
import useFetch from "../../../utils/useFetch";
import { handleLoginOnSuccess } from "../../login/Login.utils";
import { handleLogout } from "../UserProfile/PopOver.utils";

function ChangeSub({
  subTenants,
  actionValue,
  handleCancel,
  setIsLoading,
  setShowAlert,
  setActionValue,
  setErrorMessage,
  setTenantChangeDailog,
  handleSubtenantChangeSuccess,
  setIsErrorsVisible,
  setFlag,
}) {
  const isSSOUser = localStorage.getItem("isSSOUser");
  const tenantDetailsParsed = JSON.parse(localStorage.getItem("tenantDetails"));
  const subtenantID = tenantDetailsParsed?.subtenantId;
  const { instance } = useMsal();
  const history = useHistory();

  const { executeFetch } = useFetch(`${fetchEnv()?.REACT_APP_APIURL_ADMIN}`);

  const handleAction = (e) => {
    if (isSSOUser === "true" && e && e.value !== subtenantID) {
      handleSSOSwitch({ value: e.value, label: e.value });
      setActionValue({ value: e.value, label: e.value });
      return;
    }

    if (e && e.value !== subtenantID) {
      setTenantChangeDailog(true);
      setActionValue({ value: e.value, label: e.value });
    }
  };

  const handleSSOSwitch = async ({ value, _ }) => {
    try {
      setIsLoading(true);
      const msLoginResponse = await instance?.loginPopup(loginRequest);
      const id_token = msLoginResponse?.idToken;
      const headers = {
        subtenantId: value,
        tenantUUID: mapSubtenantToUUID(value),
        product: "msafety",
        "Accept-Language": "en",
        "Content-Type": "application/json",
        "Ocp-Apim-Subscription-Key": fetchEnv()?.REACT_APP_AUTH_SUBSCRIPTION_KEY,
      };
      await executeFetch({
        api: "/authservice/v1/ssoSwitchContext/microsoftonline_ad/product/msafety",
        options: {
          method: "GET",
          headers: { ...headers, Authorization: id_token },
        },
        onSuccess: async (response) => {
          if (response.statusCode >= 400) {
            setShowAlert(true);
            setErrorMessage(response?.message);
            handleCancel();
            handleLogout();
          } else {
            await handleLoginOnSuccess({
              response,
              setFlag,
              setErrorMessage,
              setIsLoading,
              setIsErrorsVisible,
              history,
            })
              .then(() => setIsLoading(false))
              .then(() => {
                handleSubtenantChangeSuccess(response?.object?.tenantDetails?.subtenantId);
              });
          }
        },
        onError: (error) => {
          setShowAlert(true);
          setErrorMessage(error?.message || t("cm.an_err"));
          setIsLoading(false);
        },
      });
    } catch (error) {
      console.error("error", error);
      setIsLoading(false);
      setErrorMessage("An error occurred while switching the tenant");
      setActionValue({ value: subtenantID, label: subtenantID });
    }
  };
  return (
    <div style={{ width: "140px", height: "86px" }}>
      <MonadSelect
        options={subTenants.map((actionData) => ({
          value: actionData,
          label: actionData,
        }))}
        value={{ value: actionValue.value, label: actionValue.label }}
        onChange={handleAction}
        name="action.value"
        isDisabled={false}
        maxMenuHeight={150}
      />
    </div>
  );
}

export default ChangeSub;
